import { useState } from "react";
import FormModal from "../../../components/FormModal/FormModal";
import Buttons from "../../../components/Buttons/Buttons";
import { useToast } from "../../../utils/ToastContext";
import { UpdateDeviceByID } from "../../../utils/apiCalls/devices";
import JsonFilePicker from "./JsonFilePicker";

const DeviceJsonUploadModal = ({ open, onClose, device, onUploaded }) => {
  const { showToast } = useToast();
  const [file, setFile] = useState(null);
  const [fileError, setFileError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const resetState = () => {
    setFile(null);
    setFileError("");
  };

  const handleClose = () => {
    resetState();
    onClose();
  };

  const handleFileSelected = (selected, error) => {
    setFile(selected);
    setFileError(error || "");
  };

  const handleUpload = async () => {
    if (!file || !device) return;
    setIsSubmitting(true);
    const formData = new FormData();
    formData.append("deviceId", device.deviceId);
    formData.append("deviceUdi", device.deviceUdi || "");
    formData.append("healthProfessionalId", device.healthProfessionalId ?? "");
    formData.append("jsonFile", file);

    try {
      const res = await UpdateDeviceByID(formData);
      const { statusCode, message } = res;
      if (statusCode === 200) {
        showToast("Device JSON uploaded successfully", "success");
        resetState();
        onUploaded?.(device);
      } else {
        showToast(message || "Failed to upload device JSON", "error");
      }
    } catch (error) {
      showToast(error?.message || "Failed to upload device JSON", "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title="Upload Device JSON"
      actions={
        <>
          <Buttons text="Cancel" variant="secondary" onClick={handleClose} />
          <Buttons
            text={isSubmitting ? "Uploading..." : "Upload"}
            variant="primary"
            onClick={handleUpload}
            disabled={!file || isSubmitting}
          />
        </>
      }
    >
      <div className="device-json-upload">
        <p className="device-json-upload_device">
          Device: <strong>{device?.deviceName || "-"}</strong>
        </p>

        <JsonFilePicker file={file} onFileSelected={handleFileSelected} error={fileError} />
      </div>
    </FormModal>
  );
};

export default DeviceJsonUploadModal;
